import { render, staticRenderFns } from "./ClickToCopy.vue?vue&type=template&id=d5e863e0&scoped=true&"
import script from "./ClickToCopy.vue?vue&type=script&lang=js&"
export * from "./ClickToCopy.vue?vue&type=script&lang=js&"
import style0 from "./ClickToCopy.vue?vue&type=style&index=0&id=d5e863e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e863e0",
  null
  
)

export default component.exports